<template>
  <td :colspan="colSpan" class="pa-0" style="padding: 0 !important; margin: 0 !important;">
    <v-card elevation="0" class="pa-0 width-100 product-card" style="border-radius: 0; margin: 0; border: none;">
      <v-card-title class="primary--text font-weight-medium pa-0" style="padding: 0 !important; margin: 0 !important;">
        <v-icon color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
        Prodotti dell'attività
      </v-card-title>
      <v-card-text class="pa-0" style="padding: 0 !important; margin: 0 !important;">
        <v-data-table
          :headers="productHeaders"
          :items="products"
          class="elevation-0 width-100 product-table"
          style="margin: 0 !important; padding: 0 !important;"
          hide-default-footer
          :items-per-page="20"
        >
      <template #header.show_alert>
        <div class="d-flex justify-center align-center">
          <v-icon small color="primary">mdi-bell-alert</v-icon>
        </div>
      </template>

      <template #item.show_alert="{ item }">
        <v-icon v-if="item.show_alert.length > 0" small color="error">
          mdi-bell-badge-outline
        </v-icon>
      </template>

      <template #item.status="{ item }">
        <v-select
            v-if="status"
            v-model="item.status_value"
            :items="status"
            item-value="value"
            item-text="text"
            dense
            @change="patchProductStatus(item)"
        ></v-select>
      </template>

      <template #item.provider="{ item }">
        <div v-if="item.provider && item.provider_id">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  text
                  small
                  @click="showProvider(item)"
              >{{ item.provider }}
              </v-btn>
            </template>
            <span>Guarda i Dettagli del Fornitore</span>
          </v-tooltip>
        </div>
        <span v-else class="grey--text">—</span>
      </template>

      <template #item.end_date="{ item }">
        {{ formatDate(item.end_date) }}
      </template>

      <template #item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }" v-if="item.subactivities > 0">
            <v-btn
                v-bind="attrs"
                :v-on="on"
                v-if="canInsertTask(item)"
                color="primary"
                x-small
                @click.stop="openTaskDialog(item)">
              <v-icon small>mdi-clock-time-eight-outline</v-icon>
            </v-btn>
          </template>
          <span>Aggiungi Ore</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                v-if="canInsertTask(item)"
                color="primary ml-2"
                x-small
                @click.stop="openTaskDetails(item)">
              <v-icon small>mdi-card-account-details-outline</v-icon>
            </v-btn>
          </template>
          <span>Guarda i Dettagli dell'attività</span>
        </v-tooltip>

        <task-dialog
            v-if="showTaskDialog"
            v-model="showTaskDialog"
            :product="product"
            @taskSaved="onTaskSaved"/>
      </template>
    </v-data-table>
    </v-card-text>
    </v-card>
    <v-card v-if="showTaskDetails" elevation="1" class="mt-4 rounded-lg task-details-card">
      <v-card-title class="primary--text font-weight-medium">
        <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
        Dettagli Attività
      </v-card-title>

      <v-card-text class="pt-4 px-4">
        <v-row>
          <v-col cols="12" md="6" lg="3">
            <div class="detail-item">
              <div class="detail-label primary--text font-weight-medium">Cod. Progetto</div>
              <div class="detail-value">{{ details.project_code || '—' }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="6" lg="3">
            <div class="detail-item">
              <div class="detail-label primary--text font-weight-medium">N° d'ordine</div>
              <div class="detail-value">{{ details.order_number || '—' }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="6" lg="3">
            <div class="detail-item">
              <div class="detail-label primary--text font-weight-medium">Data di Consegna</div>
              <div class="detail-value">
                <v-chip v-if="details.delivery_date" color="primary" outlined small class="font-weight-medium">
                  {{ formatDate(details.delivery_date) }}
                </v-chip>
                <span v-else>—</span>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6" lg="3">
            <div class="detail-item">
              <div class="detail-label primary--text font-weight-medium">Allegati</div>
              <div class="detail-value">
                <v-btn v-if="details.note_attachment" text small color="primary" :href="details.note_attachment" target="_blank">
                  <v-icon left small>mdi-file-document-outline</v-icon>
                  {{ details.note_name[0] || 'Visualizza' }}
                </v-btn>
                <span v-else>—</span>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <div class="detail-item">
          <div class="detail-label primary--text font-weight-medium">Descrizione</div>
          <div class="detail-value" v-if="details.description" v-html="details.description"></div>
          <div class="detail-value" v-else>—</div>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="showProviderDetails"
        max-width="600"
    >
      <v-card>
        <v-toolbar
            color="primary"
            dark
            class="no-hover-toolbar"
        >Dettagli Fornitore: {{ this.provider.organization_name }}
        </v-toolbar>

        <v-card-text class="pa-0">
          <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

          <div class="pa-6" v-if="!loading">
            <!-- Informazioni Fornitore -->
            <div class="mb-4">
              <h3 class="text-h6 primary--text mb-3">
                <v-icon color="primary" class="mr-2">mdi-domain</v-icon>
                {{ this.provider.organization_name || this.provider.name }}
              </h3>

              <v-card outlined class="mb-4">
                <v-card-text>
                  <div class="d-flex align-center mb-2">
                    <v-icon color="grey darken-1" class="mr-2">mdi-file-document-outline</v-icon>
                    <span class="font-weight-medium">Descrizione Invio File:</span>
                  </div>
                  <p class="ml-6 mb-0">{{ this.provider.send_file_description || 'Non specificata' }}</p>
                </v-card-text>
              </v-card>
            </div>

            <!-- Contatti -->
            <div>
              <h4 class="text-subtitle-1 primary--text mb-3">
                <v-icon color="primary" class="mr-2">mdi-contacts</v-icon>
                Contatti
              </h4>

              <div v-if="emails.length > 0">
                <v-card
                  v-for="(contatto, index) in emails"
                  :key="index"
                  outlined
                  class="mb-3"
                >
                  <v-card-text class="py-3">
                    <v-row align="center" no-gutters>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center justify-space-between">
                          <div class="d-flex align-center">
                            <v-icon color="primary" class="mr-2">mdi-email</v-icon>
                            <div>
                              <div class="caption grey--text">Email</div>
                              <div class="font-weight-medium">{{ contatto.email || 'Non specificata' }}</div>
                            </div>
                          </div>
                          <v-btn
                            v-if="contatto.email"
                            icon
                            small
                            @click="copyToClipboard(contatto.email)"
                            class="ml-2"
                          >
                            <v-icon small color="orange">mdi-content-copy</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center">
                          <v-icon color="primary" class="mr-2">mdi-phone</v-icon>
                          <div>
                            <div class="caption grey--text">Telefono</div>
                            <div class="font-weight-medium">{{ contatto.phone || 'Non specificato' }}</div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>

              <v-alert v-else type="info" outlined class="mb-0">
                <div class="d-flex align-center">
                  <v-icon class="mr-2">mdi-information</v-icon>
                  Nessun contatto disponibile per questo fornitore
                </div>
              </v-alert>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showProviderDetails = false" class="no-hover-btn">
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </td>
</template>

<script>
import TaskDialog from "./TaskDialog.vue";
import axios from "axios";
import {format, parseISO} from "date-fns";

export default {
  components: {TaskDialog},
  props: {
    products: {
      type: Array,
      required: true
    },
    operators: {
      type: Array,
      required: true
    }
  },
  computed: {
    colSpan() {
      return 5 + this.operators.length
    }
  },
  data() {
    return {
      product: null,
      details: [],
      productHeaders: [
        {text: '', value: 'show_alert', class: "primary--text font-weight-medium", align: 'center', sortable: true, width: "60px"},
        {text: 'Stato', value: 'status', class: "primary--text font-weight-medium", align: 'center', sortable: false, width: '150px'},
        {text: 'Nome Prod.', value: 'name', class: "primary--text font-weight-medium", align: 'start', width: '200px'},
        {text: 'Ore previste', value: 'scheduled_hours', class: "primary--text font-weight-medium", align: 'center', width: '120px'},
        {text: 'Diff. in Ore', value: 'delta_hours_signed', class: "primary--text font-weight-medium", align: 'center', width: '120px'},
        {text: 'Diff. in %', value: 'delta_hours_perc_signed', class: "primary--text font-weight-medium", align: 'center', width: '100px'},
        {text: 'Fornitore', value: 'provider', class: "primary--text font-weight-medium", align: 'start', width: '180px'},
        {text: 'Data Consegna', value: 'end_date', class: "primary--text font-weight-medium", align: 'center', width: '150px'},
        {text: 'Azioni', value: 'actions', class: "primary--text font-weight-medium", align: 'center', sortable: false, width: '100px'},
      ],
      showTaskDialog: false,
      showTaskDetails: false,
      showProviderDetails: false,
      status: [],
      provider: '',
      emails: [],
      number_sub_activity: null,
      downloadFileResponse: '',
      loading: false
    };
  },
  mounted() {
    this.initStatus();
  },
  methods: {
    patchProductStatus(item) {
      this.$productService.patch(item.id, {status: item.status_value})
          .then(() => {
            // Non emettiamo taskSaved per evitare il reload del progetto
            // Mostriamo solo un toast di conferma
            this.$dtoast.pop({
              rounded: "pill",
              preset: "success",
              content: `Stato aggiornato con successo`,
            })
          })
          .catch(error => {
            console.error('Errore nell\'aggiornamento dello stato:', error);
            this.$dtoast.pop({
              preset: "error",
              content: `Errore nell'aggiornamento dello stato`,
            })
          })
    },
    initStatus() {
      this.$productService.status_choices()
          .then(resp => {
            this.status = resp.data
          })
    },
    canInsertTask(item) {
      return item.operators.includes(this.$store.state.user.id)
    },
    onTaskSaved() {
      this.showTaskDialog = false;
      this.$emit('taskSaved');
    },
    openTaskDialog(item) {
      this.$productService.get(item.id).then(
          resp => {
            this.product = resp.data;
            if (resp.data.sub_activities_names.length > 0) {
              return this.showTaskDialog = true;
            }
            this.$dtoast.pop({
              preset: "error",
              content: "non hai sotto attività assegnate!",
            })
            return this.showTaskDialog = false;
          }
      )
    },
    openTaskDetails(item) {
      this.$productService.get(item.id).then(
          resp => {
            this.details = resp.data;
            this.showTaskDetails = !this.showTaskDetails
          }
      )
    },
    showProvider(item) {
      // Resettiamo gli email per evitare di mostrare quelli del fornitore precedente
      this.emails = [];
      this.loading = true;

      this.$providerService.get(item.provider_id)
          .then(resp => {
            this.provider = resp.data;
            // Le email sono già incluse nella risposta del provider
            this.emails = resp.data.emails || [];
            this.showProviderDetails = true;
            this.loading = false;
          })
          .catch(error => {
            console.error('Errore nel caricamento dei dettagli del fornitore:', error);
            this.loading = false;
          });
    },
    async downloadItem({url, label}) {
      const response = await axios.get(url, {responseType: "blob"});
      const blob = new Blob([response.data],);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    formatDate(isoDate) {
      return isoDate ? format(parseISO(isoDate), 'dd/MM/yyyy') : '-';
    },
    initialOperator(name) {
      if (!name) return '';
      return name.split(' ').map(n => n[0]).join('');
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$dtoast.pop({
            rounded: "pill",
            preset: "success",
            content: `Email copiata: ${text}`,
          })
        }).catch(err => {
          console.error('Errore nella copia:', err);
          this.fallbackCopyTextToClipboard(text);
        });
      } else {
        this.fallbackCopyTextToClipboard(text);
      }
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$dtoast.pop({
            rounded: "pill",
            preset: "success",
            content: `Email copiata: ${text}`,
          })
        } else {
          throw new Error('Comando copy non supportato');
        }
      } catch (err) {
        console.error('Fallback: Impossibile copiare', err);
        this.$dtoast.pop({
          preset: "error",
          content: `Impossibile copiare l'email`,
        })
      }
      document.body.removeChild(textArea);
    }
  }

}
</script>

<style>
/* Stile per la larghezza della tabella */
.width-100 {
  width: 100% !important;
  max-width: 100% !important;
}

.width-100 .v-data-table__wrapper {
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: auto !important;
}

.v-data-table {
  width: 100% !important;
  max-width: 100% !important;
}

.v-data-table table {
  width: 100% !important;
  table-layout: fixed !important;
  min-width: 1080px !important; /* Larghezza minima per evitare compressione */
}

/* Forza le larghezze specifiche delle colonne */
.product-table th:nth-child(1),
.product-table td:nth-child(1) {
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
}

.product-table th:nth-child(2),
.product-table td:nth-child(2) {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
}

.product-table th:nth-child(3),
.product-table td:nth-child(3) {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

.product-table th:nth-child(4),
.product-table td:nth-child(4) {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}

.product-table th:nth-child(5),
.product-table td:nth-child(5) {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}

.product-table th:nth-child(6),
.product-table td:nth-child(6) {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.product-table th:nth-child(7),
.product-table td:nth-child(7) {
  width: 180px !important;
  min-width: 180px !important;
  max-width: 180px !important;
}

.product-table th:nth-child(8),
.product-table td:nth-child(8) {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
}

.product-table th:nth-child(9),
.product-table td:nth-child(9) {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

/* Rimuove le barre di scorrimento dalla tabella prodotti */
.product-table .v-data-table__wrapper {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

/* Stile per gli elementi di dettaglio */
.detail-item {
  margin-bottom: 16px;
}

.detail-label {
  font-size: 0.875rem;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 1rem;
}

/* Stile comune per le card */
.task-details-card,
.product-card {
  background-color: white !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  margin: 0 !important;
}

.task-details-card .v-card__title,
.product-card .v-card__title {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  font-size: 1rem !important;
}

/* Stile per la tabella dei prodotti */
.product-table {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  border-radius: 4px !important;
  overflow: hidden !important;
  background-color: white !important;
  margin-top: 16px !important;
}

.product-table thead th {
  background-color: white !important;
  color: var(--v-primary-base) !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
  height: 48px !important;
  vertical-align: middle !important;
  line-height: 1 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Stile per le celle della tabella */
.product-table tbody td {
  height: 48px !important;
  vertical-align: middle !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Stile per la tabella di dettaglio */
.v-data-table tbody tr {
  transition: background-color 0.2s ease;
  background-color: white !important;
  min-height: 48px !important; /* Altezza minima per le righe */
}

.v-data-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

/* Mantiene l'altezza originale della riga quando espansa */
.v-data-table tbody tr.v-data-table__expanded {
  min-height: 48px !important;
  height: auto !important;
}

/* Assicura che le celle mantengano la loro altezza */
.v-data-table tbody tr.v-data-table__expanded td {
  vertical-align: top !important;
  min-height: 48px !important;
  padding: 12px 16px !important;
}

/* Stile per la riga di contenuto espanso */
.v-data-table tbody tr.v-data-table__expanded.v-data-table__expanded__content {
  min-height: auto !important;
  background-color: #f8fafe !important;
}

.v-data-table tbody tr.v-data-table__expanded.v-data-table__expanded__content td {
  padding: 0 !important;
  min-height: auto !important;
}

.v-data-table tbody td {
  font-size: 0.875rem !important;
  padding: 8px 16px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.v-data-table thead th {
  font-size: 0.875rem !important;
  padding: 12px 16px !important;
  background-color: white !important;
  color: var(--v-primary-base) !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}

/* Rimuove effetti hover dai pulsanti nelle modali */
.no-hover-toolbar .no-hover-btn:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.no-hover-toolbar .no-hover-btn:hover::before {
  opacity: 0 !important;
}

.no-hover-toolbar .no-hover-btn {
  transition: none !important;
}

.no-hover-btn:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.no-hover-btn:hover::before {
  opacity: 0 !important;
}

.no-hover-btn {
  transition: none !important;
}

/* Stili per evidenziare il TERZO LIVELLO: Dettagli prodotto espanso */

/* Riga prodotto espansa */
.product-table tbody tr.v-data-table__expanded {
    background: linear-gradient(90deg, #fff3e0 0%, #fef7ed 100%) !important;
    border-left: 4px solid #ff9800 !important;
    box-shadow: 0 2px 6px rgba(255, 152, 0, 0.15) !important;
    position: relative !important;
}

.product-table tbody tr.v-data-table__expanded td {
    border-bottom: 1px solid rgba(255, 152, 0, 0.2) !important;
}

/* Contenuto espanso del prodotto */
.product-table tr.v-data-table__expanded.v-data-table__expanded__content {
    background: #fef7ed !important;
    border-left: 4px solid #ff9800 !important;
    position: relative !important;
}

.product-table tr.v-data-table__expanded.v-data-table__expanded__content::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #ff9800 0%, #ffb74d 100%);
}

/* Card dei dettagli del prodotto */
.product-table .task-details-card {
    background: white !important;
    border-radius: 8px !important;
    margin: 0 !important;
    box-shadow: 0 3px 10px rgba(255, 152, 0, 0.1) !important;
    border: 1px solid rgba(255, 152, 0, 0.2) !important;
}

.product-table .task-details-card .v-card__title {
    background: linear-gradient(90deg, #fff8f0 0%, #fef7ed 100%) !important;
    border-bottom: 1px solid rgba(255, 152, 0, 0.15) !important;
    color: #e65100 !important;
    font-weight: 600 !important;
}

/* Indicatore visivo per i livelli di nesting */
.activity-table .product-table .task-details-card::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background: #ff9800;
    border-radius: 50%;
    box-shadow: 0 0 0 3px rgba(255, 152, 0, 0.2);
}

/* Migliora la leggibilità del font nella tabella prodotti */
.product-table tbody td {
    font-weight: 500 !important; /* Più pesante del normale (400) ma non bold (600) */
    font-family: 'Poppins', sans-serif !important;
}

.product-table thead th {
    font-weight: 600 !important;
    font-family: 'Poppins', sans-serif !important;
}

.product-table .v-chip {
    font-weight: 500 !important;
}

.product-table .v-btn {
    font-weight: 500 !important;
}
</style>
